export default {
  "LocationModal.Text":
    "位置情報をドコモおよびNTTドコモビジネス株式会社が利用することに同意",
  "LocationModal.ChangeButton": "登録",
  "LocationModal.UnchangeButton": "戻る",
}
